import { ColumnDef } from "@tanstack/react-table"
import { ScreenBreakpoint } from "../../../../hooks/useBreakpoint"
import { TableCustomer } from "../data/types"
import { MoneyCell } from "./MoneyCell"
import { DateCell } from "./DateCell"
import { Landmark, Mail, User } from "lucide-react"

const baseColumns: { [key: string]: ColumnDef<TableCustomer>[] } = {
	xl: [
		{
			accessorKey: "name",
			header: () => (
				<div className="text-left flex items-center gap-2">
					<User className="size-icon" />
					Cliente
				</div>
			),
			cell: ({ row }) => (
				<div className="flex flex-col">
					<span className="font-medium">{row.getValue("name")}</span>
					<span className="text-xs text-muted-foreground">
						{row.original.customer_id}
					</span>
				</div>
			),
		},
		{
			accessorKey: "contact_info",
			header: () => (
				<div className="text-left flex items-center gap-2">
					<Mail className="size-icon" />
					Contacto
				</div>
			),
			cell: ({ row }) => (
				<div className="text-left">{row.original.contact_info.email}</div>
			),
		},
		{
			accessorKey: "bank_info",
			header: () => (
				<div className="text-left flex items-center gap-2">
					<Landmark className="size-icon" />
					Datos Bancarios
				</div>
			),
			cell: ({ row }) => (
				<div className="flex flex-col">
					<div className="flex items-center gap-2">
						{row.original.sender.bank_entity?.img && (
							<img 
								src={row.original.sender.bank_entity.img} 
								alt={row.original.sender.bank_entity.name || "bank"} 
								className="w-4 h-4 rounded-sm object-contain"
							/>
						)}
						<span className="font-medium">{row.original.bank_info.alias}</span>
					</div>
					<span className="text-xs text-muted-foreground">
						{row.original.bank_info.cvu}
					</span>
				</div>
			),
		},
		MoneyCell<TableCustomer>({
			accessorKey: "balance",
			header: "Balance",
		}),
		DateCell<TableCustomer>({
			accessorKey: "creationDateTime",
			enableDateFilter: true,
		}),
	],

	lg: [
		{
			accessorKey: "name",
			header: () => (
				<div className="text-left flex items-center gap-2">
					<User className="size-icon" />
					Cliente
				</div>
			),
			cell: ({ row }) => (
				<div className="flex flex-col">
					<span className="font-medium">{row.getValue("name")}</span>
					<span className="text-xs text-muted-foreground">
						{row.original.customer_id}
					</span>
				</div>
			),
		},
		{
			accessorKey: "bank_info",
			header: () => (
				<div className="text-left flex items-center gap-2">
					<Landmark className="size-icon" />
					Datos Bancarios
				</div>
			),
			cell: ({ row }) => (
				<div className="flex flex-col">
					<div className="flex items-center gap-2">
						{row.original.sender.bank_entity?.img && (
							<img 
								src={row.original.sender.bank_entity.img} 
								alt={row.original.sender.bank_entity.name || "bank"} 
								className="w-4 h-4 rounded-sm object-contain"
							/>
						)}
						<span className="font-medium">{row.original.bank_info.alias}</span>
					</div>
					<span className="text-xs text-muted-foreground">
						{row.original.bank_info.cvu}
					</span>
				</div>
			),
		},
		MoneyCell<TableCustomer>({
			accessorKey: "balance",
			header: "Balance",
		}),
	],

	md: [
		{
			accessorKey: "name",
			header: () => (
				<div className="text-left flex items-center gap-2">
					<User className="size-icon" />
					Cliente
				</div>
			),
			cell: ({ row }) => (
				<div className="flex flex-col">
					<span className="font-medium">{row.getValue("name")}</span>
					<span className="text-xs text-muted-foreground">
						{row.original.customer_id}
					</span>
				</div>
			),
		},
		MoneyCell<TableCustomer>({
			accessorKey: "balance",
			header: "Balance",
		}),
	],

	sm: [
		{
			accessorKey: "name",
			header: () => (
				<div className="text-left flex items-center gap-2">
					<User className="size-icon" />
					Cliente
				</div>
			),
			cell: ({ row }) => (
				<div className="flex flex-col">
					<span className="font-medium">{row.getValue("name")}</span>
					<span className="text-xs text-muted-foreground">
						{row.original.customer_id}
					</span>
				</div>
			),
		},
		MoneyCell<TableCustomer>({
			accessorKey: "balance",
			header: "Balance",
		}),
	],
}

// Column getter function
export const getCustomersColumns = (
	breakpoint: ScreenBreakpoint
): ColumnDef<TableCustomer>[] => {
	return baseColumns[breakpoint]
}
